import { EnvService } from 'src/app/env.service';

const envService = new EnvService();

const API = envService.ApiUrl;

export const ApiConstants = {
  OAUTH_TOKEN: `${API}/uaa/oauth/token`,
  PAYMENT_INFO: (orderId: string) => `${API}/accounts/payment/info/${orderId}`,
  PAYMENT_PLAN: (orderId: string) => `${API}/accounts/payment/plans/v2/${orderId}`,
  CANCEL_ORDER_REQUEST: (orderId: string) => `${API}/accounts/payment/cancel/${orderId}`,
  VERIFY_OTP: `${API}/accounts/signup/verifyOtp`,
  RESEND_OTP: `${API}/accounts/signup/resendOtp`,
  SIGNUP_INIT: `${API}/accounts/signup/init`,
  NATIONAL_ID: `${API}/accounts/signup/verifyNationalId`,
  CNET_AUTHENTICATION: `${API}/accounts/signup/cinet/authentication`,
  CNET_AUTHENTICATION_STATUS: (civilId: any, referenceNo: any) => `${API}/accounts/signup/cinet/authentication/status?civilId=${civilId}&referenceNo=${referenceNo}`,
  CNET_AUTHENTICATION_TOKEN: (requestId: any, userId: any) => `${API}/accounts/signup/token/otp?requestId=${requestId}&userId=${userId}`,
  REQUEST_STATUS: `${API}/accounts/signup/nationalId/status`,
  CUSTOMER_INFO: `${API}/accounts/signup/customerInfo`,
  CREDIT_CARD: `${API}/accounts/profile/creditCard`,
  ORDER_PROCESS: `${API}/accounts/payment/processOrderPayment`,
  // INSTALLMENT_PAY_KNET: `${API}/accounts/payment/payInstallment/knet`, // old knet api
   INSTALLMENT_PAY_KNET: `${API}/accounts/payment/v2/payInstallment/knet`, // new knet api

  INSTALLMENT_PAY_APPLE: `${API}/accounts/payment/payInstallment/applepay`,
  PAYMENT_STATUS: (chargeId: string) => `${API}/accounts/payment/status/${chargeId}`,
  RETRIEVE_CHARGE: (chargeId: string) => `${API}/accounts/profile/retrieve-charge/${chargeId}`,
  ORDER_STATUS: (orderToken: string) => `${API}/accounts/payment/order/status/${orderToken}`,
  GET_FAQ_LIST: (category: string) => `${API}/accounts/faq?category=${category}`,
  GET_POLICY: (type: string) => `${API}/backoffice/taly-policy?type=${type}`,
  GET_MERCHANT: (pageParam: string) => `${API}/merchants/merchantProfile/v2/limited?${pageParam}`,

  GET_CATEGORY: `${API}/backoffice/category`,
  GET_COUNTRY: `${API}/backoffice/country`,
  GET_BUSINESS_TYPE: `${API}/backoffice/businessType`,
  GET_ANNUAL_SALES: `${API}/backoffice/annualSale`,
  GET_AVERAGE_ORDER_VALUE: `${API}/backoffice/averageOrderValue`,
  GET_PLATFORM: `${API}/backoffice/platform`,
  MERCHANT_INFO: `${API}/merchants/interestRequest`,
  GET_USER_PROFILE: `${API}/accounts/profile`,
  GET_ALL_PRESS_RELEASE: `${API}/backoffice/press-release/all?isVisible=1`,
  GET_PRESS_RELEAS_BY_ID: (id: any) => `${API}/backoffice/press-release/${id}`,
  CREATE_SESSION: (orderId:any,userId:any) => `${API}/accounts/profile/creditCard/transaction/initiate?orderId=${orderId}&userId=${userId}`,
  RESULT_INDICATOR_STATUS: (resultIndicator:any) => `${API}/accounts/profile/creditCard/transaction/status?resultIndicator=${resultIndicator}`,
  GET_TRANSACTION_STATUS: () => `${API}/accounts/profile/creditCard/transaction/status`,
  GET_MPGS_CREDITCARD: `${API}/accounts/profile/creditCard`,
  POST_APPLE_PAY: `${API}/accounts/payment/v2/payInstallment/applepay`,
  POST_APPLE_PAY_SESSION: `${API}/accounts/profile/applepay/initiate/session`
};

